export enum FSLoadingState {
    LOADING, LOADED, ERROR, INITIAL
}
